export function runClientDebug(obj)
{
  if (window.clientdebug===true)
    console.log(obj)
}